import React from 'react';
import { Link } from 'react-router-dom';
import SecretCode from './SecretCode';
import './Access.css';

function Access() {
  return (
    <div className="access-page">
      {/* Close Button - Top Right */}
      <Link to="/" className="access-close-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>
      
      <div className="access-container">
        <SecretCode />
      </div>
    </div>
  );
}

export default Access; 